<ng-template #defTemplate let-element>
  <span class="default-template">{{ element }}</span>
</ng-template>

<div (click)="toggleDropdown()" [class.disabled]="disabled" [class.open]="isOpen"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin" class="dropdown-container">
  @if (!selectedElement) {
    <span class="dropdown-placeholder">{{ placeholder }}</span>
  }
  @if (selectedElement) {
    <ng-container [ngTemplateOutlet]="template ? template : defTemplate" [ngTemplateOutletContext]="{$implicit: selectedElement}">
    </ng-container>
  }
  <div class="dropdown-controls">
    <i class="material-icons toggle">{{ isOpen ? 'expand_less' : 'expand_more' }}</i>
    @if (cancelable) {
      <i class="material-icons cancel" (click)="cancel($event)">close</i>
    }
  </div>
</div>

<!-- The panel is sized to the trigger, the way the old absolutely-positioned `left: 0; right: 0`
     one was; the backdrop is what closes it, so no document:click listener is needed. -->
<ng-template cdkConnectedOverlay appOverlayPanel matchTriggerWidth
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [panelPositions]="positions"
  (panelClose)="isOpen = false">
  <ul class="dropdown-body">
    @for (dropdownElement of list; track dropdownElement) {
      <li (click)="selectElement(dropdownElement)">
        <ng-container *ngTemplateOutlet="template ? template : defTemplate; context: {$implicit: dropdownElement}">
        </ng-container>
      </li>
    } @empty {
      <li class="empty" i18n="@@dropdown.nothing_to_select">Nothing to select</li>
    }
  </ul>
</ng-template>
